<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="membershipTiersField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeMembershipTiersField] ? 'Exclude' : 'Include')} Membership Tiers`"
      :options="membershipTiers.data"
      option-label="nameWithMembershipType"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        value => !$_.isEmpty(value) || 'Must select at least one membership tier'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeMembershipTiersField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'

export default {
  name: 'MembershipTiersConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    membershipTiersField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.MEMBERSHIP_TIERS
    },
    excludeMembershipTiersField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_MEMBERSHIP_TIERS
    }
  },
  models: {
    membershipTiers: {
      fields: ['id', 'name'],
      membershipType: {
        fields: ['id', 'name']
      }
    }
  }
}

</script>
